
import { supabase } from "@/integrations/supabase/client";

export const processVideo = async (videoId: string, videoUrl: string) => {
  try {
    console.log('Processing video:', { videoId, videoUrl });
    
    // Check if transcript already exists before making the webhook call
    const { data: existingTranscript } = await supabase
      .from('video_transcripts')
      .select('transcript')
      .eq('video_id', videoId)
      .maybeSingle();

    if (existingTranscript) {
      console.log('Transcript already exists for video:', videoId);
      return existingTranscript.transcript;
    }

    // Make webhook request to get transcript with comprehensive CORS handling
    const response = await fetch('https://hook.eu2.make.com/fr6f7fo7s2uj52euy8b87yejgfah07xt', {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Origin': window.location.origin,
      },
      body: JSON.stringify({
        videoId,
        videoUrl
      })
    });

    if (!response.ok) {
      console.error('Webhook response not OK:', {
        status: response.status,
        statusText: response.statusText,
        url: response.url
      });
      
      // More specific error messages based on response status
      if (response.status === 500) {
        throw new Error('Transcript service is temporarily unavailable. Please try again in a few minutes.');
      } else if (response.status === 429) {
        throw new Error('Too many requests. Please wait a moment before trying again.');
      } else {
        throw new Error(`Failed to get transcript: ${response.status} ${response.statusText}`);
      }
    }

    const responseText = await response.text();
    console.log('Webhook response received:', responseText);

    let transcript;
    let webhookVideoId;
    try {
      const data = JSON.parse(responseText);
      transcript = data.transcript;
      webhookVideoId = data.videoId;
      console.log('Parsed response:', { webhookVideoId, transcript });
      
      if (webhookVideoId && webhookVideoId !== videoId) {
        console.error('Webhook response videoId mismatch:', { expected: videoId, received: webhookVideoId });
        throw new Error('Received transcript for wrong video');
      }
    } catch (e) {
      console.log('Using raw response as transcript');
      transcript = responseText;
    }

    if (!transcript) {
      throw new Error('No transcript received from webhook');
    }

    // Store transcript in Supabase
    const { error: transcriptError } = await supabase
      .from('video_transcripts')
      .upsert({
        video_id: videoId,
        transcript
      });

    if (transcriptError) {
      console.error('Failed to store transcript:', transcriptError);
      throw new Error('Failed to store transcript');
    }

    console.log('Transcript stored successfully for video:', videoId);
    return transcript;
  } catch (error) {
    console.error('Video processing error:', error);
    // Check if error is our custom message, otherwise provide a generic one
    const errorMessage = error instanceof Error ? error.message : 'Failed to process video transcript. Please try again later.';
    throw new Error(errorMessage);
  }
};
